import saveFile from 'utils/file';

import type { ChartTypeRegistry } from 'chart.js';
import type { ChartJSOrUndefined } from 'react-chartjs-2/dist/types';

export const buildChartImageFileName = (blockName?: string) => {
  const sanitizedBlockName = (blockName || 'Block').replace(/["*/:<>?\\|]/g, '-').trim();
  const exportDate = new Date().toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });

  return `${sanitizedBlockName} chart - ${exportDate}.jpg`;
};

export const downloadChartImage = (
  chart: ChartJSOrUndefined<keyof ChartTypeRegistry> | null | undefined,
  fileName: string,
) => {
  if (!chart) return false;

  const dataUrl = chart.toBase64Image('image/jpeg', 1);
  if (!dataUrl) return false;

  const base64Data = dataUrl.split(',')[1];
  const binary = atob(base64Data);
  const bytes = Uint8Array.from(binary, (character) => character.codePointAt(0) ?? 0);

  saveFile(fileName, [bytes], 'image/jpeg');
  return true;
};
